import { Languages } from "./domain/enums/LanguagesEnum";

export const translations = {
    fr: {
        translation: {
            common: {
                sendEmail: "Envoyer un email",
            },
            header: {
                markets: "Marchés",
                aboutUs: "À propos",
                gallery: "Galerie",
                contacts: "Contacts",
                languages: {
                    [Languages.FR]: "Français",
                    [Languages.DE]: "Deutsch",
                },
            },
            footer: {
                privacyPolicy: "Privacy Policy",
                copyright: "© {{value}} Lavabo Lavabelle. All rights reserved.",
                studioName: "Lavabo Lavabelle",
                name1: "Barbara Schwarzwälder",
                name2: "Isabelle Jakob-Müller",
                address1: "Mettlenweg 7",
                address2: "2504 Biel/Bienne",
                telephone: "Tel: {{value}}",
                instagram: "Instagram",
            },
            heroSection: {
                einfach: "Einfach Keramik",
                title: "5 marchés rassemblant des céramistes de toute la Suisse répartis sur 5 samedis dans différentes villes",
                text1: "et",
                text2: "Nouvelles du marché de la céramique à la Pentecôte 2025",
                text3: "Nous sommes heureux d'annoncer que le traditionnel marché de la céramique (jusqu'à présent à Jegenstorf) aura désormais lieu autour du château de Landshut à Utzenstorf.",
                text4: "Week-end de Pentecôte",
                event1: "Samedi 7. juin 11-17h",
                event2: "Dimanche 8. juin 10-17h",
                event3: "Lundi 9. juin 10-17h",
            },
            marketsSection: {
                title: "Marchés {{value}}",
                text1: "5 marchés rassemblant des céramistes de toute la Suisse répartis sur 5 samedis dans différentes villes",
                button: "Plus d'informations",
                address: "Lieu de l'événement",
                time: "Heure",
                participants: "Participants au marché",
                participant: "Participant {{value}}",
            },
            discoverMarketsSection: {
                title: "Les marchés",
                paragraph1: "Découvrez l'univers de la céramique suisse",
                text1: "Découvrez des céramiques produites en Suisse et renforcez le marché artisanal local. Laissez-vous séduire par la diversité des produits en céramique en visitant nos différents marchés.",
                paragraph2: "Achetez directement auprès des artisans",
                text2: "Achetez directement chez la productrice et profitez des conseils personnalisés. Découvrez des anecdotes intéressantes relatives aux produits et à leur élaboration. Il sera très apprécié si vous payez avec de l’argent comptant afin d’éviter des frais intermédiaires.",
                paragraph3: "Un emplacement pratique pour les marchés",
                text3: "En raison de la situation centrale de chacun des marchés, vous pourrez voyager avec les transports publics par n’importe quel temps et profiter de votre visite au marché pour découvrir de nouvelles villes, par la même occasion.",
                paragraph4: "Inspirez-vous des céramistes",
                text4: "De 20 à 40 exposants seront présents sur chacun des marchés pour vous présenter leurs nouvelles créations.",
            },
            organisatorsSection: {
                title: "Organisation",
                text1: "Nous, Isabelle Jakob-Müller et Barbara Schwarzwälder de l’atelier Lavabo Lavabelle, créons et produisons nos céramiques dans notre atelier à Bienne depuis plus de 25 ans.",
                text2: "L’idée Einfach Keramik nous est venue lors de la pandémie alors que nos canaux de distribution et de vente étaient complètement bloqués.",
                text3: "Comment pouvons-nous continuer à proposer nos produits aux clientes intéressées?",
                text4: "L’idée de proposer des marchés en plein air a tout de suite trouvé écho auprès de nos différentes et différents collègues qui se trouvaient dans la même situation. Nous avons donc organisé une première série de Einfach Keramik. L’intérêt suscité auprès du public et des participants a été si favorable que nous avons décidé de continuer ce type de marchés dans de nouveaux et charmants endroits.",
                text5: "C’est pourquoi nous organisons Einfach Keramik depuis 2020 dans toute la Suisse.",
                text6: "Notre but est de proposer des céramiques artisanales à un public intéressé.",
                indicator1: "+25",
                indicatorName1: "Marchés",
                indicator2: "+27",
                indicatorName2: "Ans d'expérience",
                indicator3: "+300",
                indicatorName3: "Des clients satisfaits",
            },
            gallerySection: {
                title: "Galerie photo",
                text1: "Nous nous réjouissons de vous rencontrer lors de votre prochaine visite.",
            },
            privacyPolicy: {
                title: "Privacy Policy",
                text1: "Nous respectons votre vie privée et nous nous engageons à garantir la transparence dans l'utilisation de notre site.",
                subTitle1: "Aucune collecte de données",
                text2: "Le site Lavabo Lavabelle ne collecte aucune donnée personnelle des utilisateurs. Nous ne demandons, ne traitons et ne stockons aucune information telle que votre nom, votre adresse email, votre numéro de téléphone ou toute autre donnée personnelle.",
                subTitle2: "Pas d'utilisation de cookies",
                text3: "Nous n'utilisons pas de cookies ou d'autres technologies de suivi pour collecter des informations sur vos visites ou votre comportement sur le site.",
                subTitle3: "Objectif du site",
                text4: "Le site Lavabo Lavabelle fournit des informations sur nos produits et services. Vous pouvez l'utiliser librement, sans avoir à vous soucier de votre vie privée.",
                subTitle4: "Mises à jour de la politique",
                text5: "Nous pouvons modifier cette politique de confidentialité afin de refléter les mises à jour de notre approche en matière de confidentialité. Toutes les modifications seront publiées sur cette page.",
                text6: "Si vous avez des questions concernant la confidentialité, vous pouvez nous contacter via les coordonnées disponibles sur le site.",
                okay: "Okay",
            },
        },
    },

    de: {
        translation: {
            common: {
                sendEmail: "Eine E-Mail senden",
            },
            header: {
                markets: "Märkte",
                aboutUs: "Über uns",
                gallery: "Galerie",
                contacts: "Kontakt",
                languages: {
                    [Languages.FR]: "Français",
                    [Languages.DE]: "Deutsch",
                },
            },
            footer: {
                privacyPolicy: "Privacy Policy",
                copyright: "© {{value}} Lavabo Lavabelle. All rights reserved.",
                studioName: "Lavabo Lavabelle",
                name1: "Barbara Schwarzwälder",
                name2: "Isabelle Jakob-Müller",
                address1: "Mettlenweg 7",
                address2: "2504 Biel/Bienne",
                telephone: "Tel: {{value}}",
                instagram: "Instagram",
            },
            heroSection: {
                einfach: "Einfach Keramik",
                title: "Fünf Märkte an Fünf Samstagen in verschiedenen Städten mit Keramikschaffenden aus der ganzen Schweiz",
                text1: "und",
                text2: "Neuigkeiten zum Keramikmarkt an Pfingsten 2025",
                text3: "Wir freuen uns, dass der traditionelle Keramikmarkt (bisher in Jegenstorf) neu ums Schloss Landshut in Utzenstorf stattfinden wird.",
                text4: "Pfingstwochenende",
                event1: "Samstag 7. Juni  11-17h",
                event2: "Sonntag 8. Juni  10-17h",
                event3: "Montag 9. Juni 10-17h",
            },
            marketsSection: {
                title: "Märkte {{value}}",
                text1: "Fünf Märkte an fünf Samstagen in verschiedenen Städten mit Keramikschaffenden aus der ganzen Schweiz",
                button: "Mehr Informationen",
                address: "Ort",
                time: "Zeit",
                participants: "Teilnehmer*innen am Markt",
                participant: "Teilnehmer*innen {{value}}",
            },
            discoverMarketsSection: {
                title: "Über die Märkte",
                paragraph1: "Entdecken sie Keramik aus der Schweiz",
                text1: "Entdecken sie in der Schweiz produzierte Keramik und stärken sie lokales Handwerk. Lassen sie sich von der keramischen Vielfalt überraschen beim Besuch der Einfach Keramik Märkte",
                paragraph2: "Direkt bei den Handwerker*innen einkaufen",
                text2: "Kaufen sie direkt bei den Produzent*innen und profitieren sie von der persönlichen Beratung. Erfahren sie interessante Geschichten rund um die Produkte und ihre Herstellung. Es wird geschätzt, wenn sie mit Bargeld bezahlen, so landet der ganze Betrag bei den Hersteller*innen",
                paragraph3: "Märkte an bester Lage",
                text3: "Durch die zentrale Lage der jeweiligen Märkte können sie problemlos mit dem ÖV anreisen und den Marktbesuch damit verbinden, bei jedem Wetter attraktive Städte neu zu entdecken",
                paragraph4: "Geniessen sie die Marktatmosphäre",
                text4: "Pro Standort erwarten sie 20 bis 40 Keramiker*innen mit ihren neusten Kreationen",
            },
            organisatorsSection: {
                title: "Organisation",
                text1: "Wir sind Isabelle Jakob-Müller und Barbara Schwarzwälder von Lavabo Lavabelle. Seit über 25 Jahren gestalten und produzieren wir Keramik in unserer Werkstatt in Biel.",
                text2: 'Die Idee "Einfach Keramik" entstand während der Coronazeit, als unsere Verkaufskanäle komplett blockiert wurden.',
                text3: "Wie können wir unsere Produkte weiterhin an interessierte Kund*innen bringen?",
                text4: "Die Idee, an der frischen Luft Märkte zu  veranstalten kam bei unseren Kolleg*innen, die dasselbe Problem hatten, gut an. Wir organisierten eine erste Serie Einfach Keramik. Der Anklang beim Publikum und bei den Teilnehmer*innen war so gut, dass wir uns entschieden, die Marktserie an immer neuen, schönen Orten fortzusetzen.",
                text5: "Darum organisieren wir seit 2020 Einfach Keramik in der ganzen Schweiz.",
                text6: "Unser Ziel ist, handwerklich produzierte Keramik an ein interessiertes Publikum zu bringen.",
                indicator1: "+25",
                indicatorName1: "Märkte",
                indicator2: "+27",
                indicatorName2: "Jahre Erfahrung",
                indicator3: "+300",
                indicatorName3: "Zufriedene Kunden",
            },
            gallerySection: {
                title: "Galerie photo",
                text1: "Wir freuen uns darauf, Sie bei Ihrem nächsten Besuch zu treffen.",
            },
            privacyPolicy: {
                title: "Privacy Policy",
                text1: "Wir respektieren Ihre Privatsphäre und verpflichten uns zu Transparenz bei der Nutzung unserer Website.",
                subTitle1: "Keine Datenerhebung",
                text2: "Die Website Lavabo Lavabelle sammelt keine persönlichen Daten der Nutzer. Wir fordern keine Informationen an, verarbeiten oder speichern keine Daten wie Ihren Namen, Ihre E-Mail-Adresse, Ihre Telefonnummer oder andere persönliche Informationen.",
                subTitle2: "Keine Verwendung von Cookies",
                text3: "Wir verwenden keine Cookies oder andere Tracking-Technologien, um Informationen über Ihre Besuche oder Ihr Verhalten auf der Website zu sammeln.",
                subTitle3: "Zweck der Website",
                text4: "Die Website Lavabo Lavabelle bietet Informationen über unsere Produkte und Dienstleistungen. Sie können sie frei nutzen, ohne sich um Ihre Privatsphäre sorgen zu müssen.",
                subTitle4: "Aktualisierungen der Richtlinie",
                text5: "Wir können diese Datenschutzrichtlinie ändern, um Aktualisierungen unseres Ansatzes in Bezug auf den Datenschutz widerzuspiegeln. Alle Änderungen werden auf dieser Seite veröffentlicht.",
                text6: "Wenn Sie Fragen zum Datenschutz haben, können Sie uns über die auf der Website verfügbaren Kontaktinformationen erreichen.",
                okay: "Okay",
            },
        },
    },
};
